import { useParams } from "react-router-dom"
import { Conditional, Stack } from "src/shared/components"
import InvoiceInfoRow from "src/modules/invoices/components/invoice-info-row"
// import GrnInvoiceTable from "./grn-invoice-table"
import TransferListInvoiceTable from "./transfer-list-invoice-table"
import { Typography } from "@mui/material"
import { useGetTransferForInvoiceQuery } from "src/graphql/quark/quark.type"
import { useMemo } from "react"
import { groupBy } from "src/shared/utils/groupBy"
import { useTypedSelector } from "src/shared/store/store"
const TransferListInvoice = () => {
  const { id } = useParams()
  const auth = useTypedSelector((state) => state.authentication)
  const { data } = useGetTransferForInvoiceQuery({ variables: { getTransferId: id as string }, skip: !id })
  const receiveList = useMemo(() => {
    if (!data?.getTransfer?.transferItems) return []

    const groupedProducts = groupBy(data.getTransfer.transferItems, (item) => item.productLot?.product?.id)

    return Object.entries(groupedProducts).map(([productId, items]) => ({
      quantity: items.reduce((acc, val) => {
        acc += val?.quantity ?? 0
        return acc
      }, 0),
      productId,
      productSecondaryId: items[0]?.productLot?.product?.secondaryId,
      productName: items[0]?.productLot?.product?.name
    }))
  }, [data?.getTransfer?.transferItems])
  return (
    <Stack direction={"row"} justifyContent={"center"} sx={{ background: "var(--slipBackground)" }}>
      <Stack width="100%" minWidth="800px" mt={4} sx={{ background: "var(--slipBackground)" }} p={3}>
        <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
          <img src={auth?.tenant?.logo as string} width={"150px"} alt="img" />
          <Conditional condition={!!auth?.tenant?.parentCompanyLogo}>
            <img src={auth?.tenant?.parentCompanyLogo as string} width={"150px"} alt="img" />
          </Conditional>
        </Stack>
        <Typography color="var(--slipColor)" variant="h3" textAlign={"center"}>
          Transfer List
        </Typography>
        <Stack mb={3}>
          <InvoiceInfoRow justifyContent="flex-start" title="Transfer ID" value={`${data?.getTransfer?.secondaryId}`} />
          <InvoiceInfoRow
            justifyContent="flex-start"
            title="Transfer From"
            value={`${data?.getTransfer?.locationFrom?.name}`}
          />
          <InvoiceInfoRow
            justifyContent="flex-start"
            title="Location To"
            value={`${data?.getTransfer?.locationTo?.name}`}
          />
          <InvoiceInfoRow
            justifyContent="flex-start"
            title="Demand Note ID"
            value={`${data?.getTransfer?.demandNote?.secondaryId ?? ""}`}
          />
        </Stack>

        <TransferListInvoiceTable transferList={receiveList} />
      </Stack>
    </Stack>
  )
}

export default TransferListInvoice
